export default __webpack_public_path__ + "static/media/puneqr.614fc56a.png";